import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService implements OnDestroy
{
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Constructor
     *
     * @param {MediaObserver} _mediaObserver
     */
    constructor(
        private _mediaObserver: MediaObserver
    )
    {
        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();

    }

    private mediaSubscription!: Subscription;
    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void
    {
        this._mediaObserver
            .asObservable()
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((change) => {
                change.forEach((item) => {
                    this.activeMediaQuery = item 
                    ? `'${item.mqAlias}' = (${item.mediaQuery}`
                    : ''; 
                    if (item.mqAlias = 'md') {
                        this.loadMobileContent();
                    }
                });
            });
    }

    ngOnDestroy() : void {
        this.mediaSubscription.unsubscribe();
    }


    loadMobileContent() {
        // Do something when we got the viewport of a mobile
    }
}
